<!-- Loader con overlay -->
<div 
  *ngIf="isLoading" 
  class="loader-container"
  [class.loader-overlay]="overlay"
  [class.loader-transparent]="transparent">
  
  <!-- Contenido del loader -->
  <div class="loader-content" [ngClass]="'loader-' + size">
    <!-- Spinner animado -->
    <div class="spinner" [ngClass]="'spinner-' + size">
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring last"></div>
    </div>
    
    <!-- Mensaje de carga -->
    <p class="loader-message" [ngClass]="'message-' + size">
      {{ message }}
    </p>
  </div>
</div>